import { Button } from './Button';
import { EnvelopeIcon } from '@heroicons/react/24/solid';
import { FacebookIcon } from './icons/FacebookIcon';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import ShareIcon from '@mui/icons-material/Share';
import { twMerge } from 'tailwind-merge';

type Size = 'small' | 'medium' | 'large';
type Social = 'whatsapp' | 'facebook' | 'email' | 'share';

interface SocialButtonProps {
  size?: Size;
  social?: Social;
  href?: string;
}

const Sizes: Record<Size, string> = {
  small: 'p-1.5 text-sm',
  medium: 'p-2 text-lg',
  large: 'p-3 text-xl',
};

const Socials: Record<Social, string> = {
  whatsapp: 'bg-whatsapp hover:bg-whatsapp/[0.8]',
  facebook: 'bg-facebook hover:bg-facebook/[0.8]',
  email: 'bg-blue hover:bg-email/[0.8]',
  share: 'bg-primary-600 hover:bg-primary-700',
};

const icon = {
  whatsapp: WhatsAppIcon,
  facebook: FacebookIcon,
  email: EnvelopeIcon,
  share: ShareIcon,
};

export function SocialButton({
  size = 'small',
  social = 'share',
  href,
  ...props
}: SocialButtonProps): React.ReactElement {
  const defaultClasses = 'rounded-full border-0';
  const classNames = social
    ? twMerge(defaultClasses, Sizes[size], Socials[social])
    : defaultClasses;

  const SocialIcon = icon[social];

  return (
    <Button {...props} as="a" href={href} target="_blank" rel="noopener" className={classNames}>
      <SocialIcon className="h-5 w-5" />
    </Button>
  );
}
